
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class InputSelected extends Vue {
  @Prop(Boolean) private readonly searchLoad!: string;
  @Prop(String) private readonly text!: string;
  @Prop(Number) private readonly id!: number;
  @Prop(String) private readonly model!: string;
  @Prop(Array) private readonly serverItems!: string[];
}
